import React from 'react'
import { useAppDispatch } from '../../../../hooks/redux'

import BaseModal from '../BaseModal2'
import ModalInput from '@SonarCX/components/atoms/ModalInput'
import Button from '@SonarCX/components/atoms/Button2'

import { addFolder } from '../../../../slices/article'
import useStyles from './styles'

const NewDocumentFolderModal = ({ parent, addBelow, onClose }) => {
  const dispatch = useAppDispatch()

  const [name, setName] = React.useState('')

  const classes = useStyles()

  const handleClose = React.useCallback(() => {
    setName('')
    onClose()
  }, [onClose])

  const handleCreate = React.useCallback(() => {
    const trimmed = name.trim()
    dispatch(addFolder(trimmed, parent, addBelow))

    handleClose()
  }, [name, dispatch, parent, addBelow, handleClose])

  return (
    <BaseModal open onClose={handleClose} title='New Folder'>
      <div className={classes.title}>Folder Name</div>

      <ModalInput
        value={name}
        onChange={e => setName(e.target.value)}
        placeholder='Enter folder name'
        className={classes.input}
      />

      <Button
        onClick={handleCreate}
        disabled={name.trim().length === 0}
        className={classes.button}
      >
        Create Folder
      </Button>
    </BaseModal>
  )
}

export default NewDocumentFolderModal
